module.exports = __webpack_public_path__ + "static/img/closeFullScreen.ad81bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/closeFullScreen.png
// module id = cLCY
// module chunks = 0